import { createEvent, createStore, sample } from "effector";
import {
  createBrowserRouter,
  redirect as nativeRedirect,
  FormEncType,
  FormMethod,
  RouteObject,
} from "react-router-dom";

const initialize = createEvent<RouteObject[]>();
const $instance = createStore<ReturnType<typeof createBrowserRouter> | null>(
  null
);

const $initialized = $instance.map((value) => value !== null);

sample({
  clock: initialize,
  fn: (routes) => createBrowserRouter(routes),
  target: $instance,
});

//#region Navigate
export type NavigatePayload =
  | {
      to: string;
      replace?: boolean;
      state?: unknown;
      preventScrollReset?: boolean;
      formMethod?: FormMethod;
      formEncType?: FormEncType;
      formData?: FormData;
    }
  | number;

const navigate = createEvent<NavigatePayload>();

sample({
  clock: navigate,
  source: $instance,
  filter: Boolean,
  fn: (router, payload) => ({
    router,
    payload,
  }),
}).watch(({ router, payload }) => {
  if (typeof payload === "number") {
    return router.navigate(payload);
  }

  const { to, ...navigateOptions } = payload;

  router.navigate(to, navigateOptions);
});
//#endregion

//#region Redirect
type Redirect = {
  to: string;
};

const redirect = createEvent<Redirect>();

redirect.watch((params) => {
  nativeRedirect(params.to);
});
//#endregion

//#region GoBack
const goBack = createEvent();

goBack.watch(() => {
  if (window.history?.length && window.history.length > 1) {
    router.navigate(-1);
  } else {
    router.navigate({
      to: "/",
      replace: true,
    });
  }
});
//#endregion

export const router = {
  $instance,
  $initialized,
  initialize,
  navigate,
  redirect,
  goBack,
};
